export default "__VITE_ASSET__nrOP8j1K__"